import { FC } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowUpFromBracket,
  faMicrophone,
} from '@fortawesome/pro-regular-svg-icons';
import { useTranslations } from 'next-intl';

interface Props {
  onRecord: () => void;
  onUpload: () => void;
}

// The two ways to add audio, shown while the memo has none.
export const AudioOptionCards: FC<Props> = ({ onRecord, onUpload }) => {
  const t = useTranslations();

  return (
    <div className={styles.row}>
      <button type="button" onClick={onRecord} className={styles.card}>
        <span className={classNames(styles.well, styles.recordWell)}>
          <FontAwesomeIcon icon={faMicrophone} aria-hidden="true" />
        </span>
        <span className={styles.text}>
          <span className={styles.title}>{t('memoComposer.audio.record')}</span>
          <span className={styles.subtitle}>
            {t('memoComposer.audio.recordSubtitle')}
          </span>
        </span>
      </button>

      <button type="button" onClick={onUpload} className={styles.card}>
        <span className={styles.well}>
          <FontAwesomeIcon icon={faArrowUpFromBracket} aria-hidden="true" />
        </span>
        <span className={styles.text}>
          <span className={styles.title}>{t('memoComposer.upload')}</span>
          <span className={styles.subtitle}>
            {t('memoComposer.audio.uploadSubtitle')}
          </span>
        </span>
      </button>
    </div>
  );
};

const styles = {
  row: 'grid grid-cols-2 gap-3',
  card: classNames(
    'flex items-center gap-3 rounded-xl border border-stroke bg-surface-card px-3 py-2.5 text-left shadow-xs',
    'hover:bg-ink-secondary/5 focus:outline-hidden focus-visible:border-accent-ink focus-visible:ring-2 focus-visible:ring-accent-ink/20',
  ),
  well: 'flex size-9 shrink-0 items-center justify-center rounded-lg bg-surface-field text-[15px] text-ink-primary',
  recordWell: 'bg-mf-red-600/10 text-mf-red-600',
  text: 'flex min-w-0 flex-col',
  title: 'text-sm font-semibold text-ink-primary',
  subtitle: 'truncate text-xs text-ink-secondary',
};
